import { useEffect, useState } from "react";
import { PermissionCategory } from "../../../http/protocol";
import { t } from "../../../i18n";
import { getContainer } from "../../../ioc/IOCSetup";
import { MetricsSingleValuePanel } from "../../metrics/MetricSingleValuePanel";
import { PermissionRequired } from "../../security/PermissionRequired";

export function PendingTransactionsCard() {
  const [numberOfPendingTransactions, setNumberOfPendingTransactions] = useState<number>(0);
  const criticalAmountOfPendingTransactions = 50

  useEffect(() => {
    let ignore = false;
    getContainer()
      .getSupervisorService()
      .countPendingTransactions()
      .then(({ count }) => {
        if (!ignore) setNumberOfPendingTransactions(count);
      })
      .catch((err) => console.error("Failed to fetch pending transaction count", err));
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <PermissionRequired
      permissions={[PermissionCategory.SUPERVISOR]}
      accessLevel={"r"}
      showError={false}
    >
      <MetricsSingleValuePanel
        header={""}
        mainTitle={t("home.dashboard.card.pendingTransactions")}
        mainValue={numberOfPendingTransactions}
        type={numberOfPendingTransactions > criticalAmountOfPendingTransactions ? "ERROR" : numberOfPendingTransactions > 0 ? "WARNING" : "OK"}
        navTo={"/admin/admin-transactions"}
        listRequest={{}}
      />
    </PermissionRequired>
  );
}
